import { axios, AxiosResponse } from '@/config/plugins/axios';

const ErrorHandler = {
	/**
	 * Add an interceptor to handle the typeException with axios
	 */
	addGlobalHandlingTypeException(typeException: string, codeException: number, callback: () => void) {
		const conditionCallback = (error: any) => {
			// Si l'erreur est une erreur de token expiré :
			if (codeException === error.response.data.code) {
				if (typeException === error.response.data.type) {
					callback();
				}
			}
		};

		this.addGlobalHandling(conditionCallback);
	},

	/**
	 * Add an interceptor to handle the error with axios
	 */
	addGlobalHandlingError(errorMessage: string, codeException: number, callback: () => void) {
		const conditionCallback = (error: any) => {
			// Si l'erreur est une erreur de token expiré :
			if (codeException === error.response.status) {
				if (errorMessage === error.response.data.message || errorMessage === error.response.data.error) {
					callback();
				}
			}
		};

		this.addGlobalHandling(conditionCallback);
	},

	addGlobalHandling(callback: (error: object) => void) {
		axios.interceptors.response.use(
			(response: AxiosResponse) => response,
			(error) => {
				// Si l'erreur est une erreur de token expiré :
				callback(error);

				// https://github.com/axios/axios/issues/1226
				// Needed to check every interceptor
				return Promise.reject(error);
			}
		);
	}
};

export default ErrorHandler;
